import { CommonApiService } from '../../services/api/common-api.service';
import { Config, WEB_CONFIG } from '../../config';
import { PermissionsService } from '../../permissions/permissions.service';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { LocalStorageEventsService } from '../../event/storage/local-storage-events.service';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Theme } from '../../decorators/theme.decorator';
import { OverlayContainer } from '@angular/cdk/overlay';
import { PermissionsInterface } from '../../interfaces/permissions.interface';
import { ToasterEventsService } from '../../toaster/toaster-events.service';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '../../services/storage/session-storage.service';
import { CookieService } from 'ngx-cookie-service';
import { User } from '../../decorators/user.decorator';
import { AuthUserModel } from '../../models';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'sc-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, PermissionsInterface {
  @Theme() public theme: string;
  @User() public user: AuthUserModel;

  @Output() toogleMenuEvent = new EventEmitter();

  public lang: string;
  public isHide = false;
  public currentScroll = 0;
  public searchType;
  public inputText = '';
  public env: string;
  private readonly apiUrl: string;

  constructor(
    private router: Router,
    private localStorageEvents: LocalStorageEventsService,
    private localStorage: LocalStorageService,
    private toasterService: ToasterEventsService,
    private translate: TranslateService,
    private commonApiService: CommonApiService,
    private sessionStorageService: SessionStorageService,
    private permissionsService: PermissionsService,
    private overlayContainer: OverlayContainer,
    private cookieService: CookieService,
    @Inject(WEB_CONFIG) private config: Config
  ) {
    this.apiUrl = this.config.api_url;
  }

  public ngOnInit() {
    this.initPermissionsService();
    this.lang = this.localStorage.get('lang') || 'fr';
    this.env = this.config.env.toLowerCase();
    this.localStorageEvents.localStorageEvent.subscribe(() => {
      this.lang = this.localStorage.get('lang');
    });
  }

  @HostListener('window:scroll', [])
  public onWindowScroll() {
    const numberVar = document.documentElement.scrollTop;
    if (numberVar > this.currentScroll) {
      this.isHide = true;
    }
    if (numberVar < this.currentScroll) {
      this.isHide = false;
    }
    this.currentScroll = numberVar;
  }

  public emitToggleMenuEvent() {
    this.toogleMenuEvent.emit();
  }

  public search() {
    switch (this.searchType) {
      case '1':
        break;
      case '2':
        break;
      case '3':
        break;
      case '4':
        this.commonApiService
          .getProductGlobalSearch(this.inputText, 'fr')
          .subscribe(products => {
            this.sessionStorageService.post('textGlobalSearch', this.inputText);
            if (!isNotNullOrUndefined(products) || products.length === 0) {
              this.toasterService.warnEvent(
                this.translate.instant('CORE.GLOBAL_SEARCH.TOAST.NO_RESULT_PRODUCT')
              );
            }
            if (products.length === 1) {
              this.sessionStorageService.post('productId', products[0].id);
              const url = this.permissionsService.hasPermission('UNIVERSAL_ROLE') ? '/purchase-order/search/product/'
                + products[0].id : '/product/consult/' + products[0].id;
              this.navigate('video', url);
            } else {
              this.sessionStorageService.post(
                'productGlobalSearchResutls',
                products
              );
              const url = '/product/globalProductSearch';
              this.navigate('video', url);
            }
          });
        break;
      case '5':
        if (this.inputText.length > 0) {
          this.commonApiService
            .getPurchaseOrderByGlobalSearch(this.inputText, 'fr')
            .subscribe(purchaseOrders => {
              if (
                !isNotNullOrUndefined(purchaseOrders) ||
                purchaseOrders.length === 0
              ) {
                this.toasterService.warnEvent(
                  this.translate.instant(
                    'CORE.GLOBAL_SEARCH.TOAST.NO_RESULT_PURCHASE_ORDER'
                  )
                );
              }
              if (purchaseOrders.length === 1) {
                this.navigate('video', '/purchase-order/consult/' + purchaseOrders[0].id);
              } else {
                this.sessionStorageService.post(
                  'purchaseOrderGlobalSearchResults',
                  purchaseOrders
                );
                this.navigate('video', '/purchase-order/globalPurchaseOrderSearch');
              }
            });
        } else {
          this.toasterService.warnEvent(
            this.translate.instant('CORE.GLOBAL_SEARCH.TOAST.NO_INPUT_TEXT_PO')
          );
        }
        break;
      default:
        break;
    }
  }

  public returnToDashboard() {
    window.location.href = this.apiUrl + '/dashboard';
  }

  public initPermissionsService(): void {
    this.permissionsService.init();
  }

  public switchTheme() {
    if (this.theme === 'dark') {
      this.localStorage.post('newTheme', 'light');
      this.overlayContainer
        .getContainerElement()
        .classList.remove('dark-theme');
      this.overlayContainer.getContainerElement().classList.add('light-theme');
    } else {
      this.localStorage.post('newTheme', 'dark');
      this.overlayContainer
        .getContainerElement()
        .classList.remove('light-theme');
      this.overlayContainer.getContainerElement().classList.add('dark-theme');
    }
  }

  public logout() {
    this.sessionStorageService.delete('authToken');
    this.cookieService.delete('auth-mail');
    window.location.reload();
  }

  stopIdentityTheft() {
    sessionStorage.removeItem('authTokenSecondary');
  }

  public navigate(module = '', route: string) {
    if (!route.startsWith('/')) {
      route = '/' + route;
    }

    const url = this.config.api_url + (module ? `/${module}` : '') + route;

    if (window.location.href === url) {
      window.location.reload();
    } else if (window.location.pathname.startsWith(`/${module}`)) {
      this.router.navigateByUrl(route);
    } else {
      window.location.href = url;
    }
  }
}
